import { useAuth0 } from '@auth0/auth0-react';
import SoftButton from "components/SoftButton";

import PropTypes from "prop-types";


const LogoutButton = ({children}) => {
	const { logout, isAuthenticated } = useAuth0();

	return (
		isAuthenticated && (
			<SoftButton onClick={() => logout()}>
				{children}
			</SoftButton>
		)
	)
}
  
  // Typechecking props of the LogoutButton
  LogoutButton.propTypes = {
	children: PropTypes.node.isRequired,
  };
  

export default LogoutButton